import { z } from 'zod';
import { ReadInstituicaoEnsinoDto } from '@/api.types';
import { normalizeInstituicaoFormFromApi } from '@/modules/structure/instituicoes/instituicao-form.utils';
import {
  enderecoFormSchema,
  requiredIntFromNumberInput,
  telefoneRequiredFormSchema,
} from '@/shared/utils/formZod.schema.utils';

function nullToEmpty(val: unknown): string {
  return val == null ? '' : String(val);
}

const optionalNullableStringSchema = z.preprocess(nullToEmpty, z.string().trim().optional());

const instituicaoFormBaseSchema = z
  .object({
    ordem: requiredIntFromNumberInput({
      requiredMessage: 'Informe a ordem',
      min: 0,
      minMessage: 'A ordem deve ser zero ou maior',
    }),
    razao_social: z.string().trim().min(1, 'Informe a razão social'),
    cnpj: z
      .string()
      .trim()
      .min(1, 'Informe o CNPJ')
      .refine((v) => v.replace(/\D/g, '').length === 14, 'CNPJ inválido'),
    representante_nome: optionalNullableStringSchema,
    representante_cargo: optionalNullableStringSchema,
    endereco: enderecoFormSchema,
    telefone: telefoneRequiredFormSchema,
  })
  .passthrough();

export const instituicaoFormSchema = z.preprocess(
  (val) =>
    val != null && typeof val === 'object'
      ? normalizeInstituicaoFormFromApi(val as ReadInstituicaoEnsinoDto)
      : val,
  instituicaoFormBaseSchema,
);

export type InstituicaoFormValues = z.infer<typeof instituicaoFormBaseSchema>;
